var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiAccordion from '@material-ui/core/Accordion';
import styled from 'styled-components';
import palette from '../palette';
var StyledAccordion = styled(MuiAccordion)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    background-color: ", ";\n  }\n"], ["\n  &&& {\n    background-color: ",
    ";\n  }\n"])), function (props) {
    return props.disabled ? palette.background.paper : undefined;
});
/**
 * Kareo wrapped component of the Material-UI Accordion. The prop API has been limited to props defined in AccordionProps.
 *
 * Material-UI Accordion: [Docs](https://v4.mui.com/components/accordion/), [API](https://v4.mui.com/api/accordion/)
 *
 * @storybook: [Accordion](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-accordion--simple-and-disabled-accordion)
 */
var Accordion = React.forwardRef(function (props, ref) { return React.createElement(StyledAccordion, __assign({}, props, { ref: ref })); });
Accordion.displayName = 'KareoAccordion';
export default Accordion;
var templateObject_1;
